import { client } from "@/apis/client";
import { bytesToGB } from "@/utils";
import { useQuery } from "@tanstack/react-query";

// TODO: API Docs 적용이 안되어있음
const useUserMeteringQuery = ({ userId }: { userId: number }) => {
  return useQuery({
    queryKey: ["user-metering"],
    queryFn: async () =>
      client.GET(`/api/job-metering/user/{userId} `, {
        params: {
          path: {
            userId,
          },
        },
      }),

    enabled: !!userId,
    select: (data) => {
      const {
        total_size_byte,
        total_reanalysis_count,
        total_reselection_count,
        job_metering_info,
      } = data.data;

      const total_size_gigabyte = bytesToGB(total_size_byte);

      return {
        total_size_byte,
        total_reanalysis_count,
        total_reselection_count,
        total_size_gigabyte,
        total_re_count: total_reanalysis_count + total_reselection_count,
        job_metering_info,
      };
    },
  });
};

export default useUserMeteringQuery;
